import { PAYMENT_MODULE } from "@/api_framework/api_config";
import { IInvoiceAdjustmentSummary, IInvoiceAdjustmentUploadPayload } from "@/api_framework/api_modals/payment";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});

interface IAPIResponse {
  status: boolean;
  message: string;
  data: IInvoiceAdjustmentSummary;
}

// Pre-upload preview: checks the uploaded invoice numbers against the DB, writes nothing
export const useInvoiceAdjustmentSummaryAPI = () => {
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(
    async (
      payload: IInvoiceAdjustmentUploadPayload,
    ): Promise<{ status: boolean; message: IInvoiceAdjustmentSummary | null }> => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        return await axios
          .post(PAYMENT_MODULE?.INVOICE_ADJUSTMENT_SUMMARY?.baseURL ?? "", payload, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IAPIResponse>) => {
            if (res.data.status) {
              return { status: true, message: res.data.data };
            }
            return { status: false, message: null };
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config?.["curlCommand"]);
            captureError(e);
            return { status: false, message: null };
          });
      } catch (e) {
        captureError(e as AxiosError);
        return { status: false, message: null };
      }
    },
    [captureError, configuration.localStorage.ACCESS_TOKEN.key, sendCurl],
  );

  return { execute };
};
